export default __webpack_public_path__ + "static/media/settings.aff7c62e.png";